import { UNDERLINE_TAB_ATTR, UnderlineTabBar, underlineTabItemClassName, underlineTabLabelClassName } from '@frontend/components/common';

import { useTabFilter } from './tab-filter.controller';

export interface TabFilterProps {
    onChange?: (value: string) => void;
    keys: string[];
    /**
     * displayMap key should match the keys prop.
     */
    displayMap: Map<string, React.ReactNode>;
    /**
     * Optional map to return a different key than the one used in keys.
     * If not provided, the keys will be used as is.
     */
    returnMap?: Map<string, string>;
    defaultActive?: string;
    useQueryParams?: {
        key: string;
    };
    /**
     * Optional array of query param keys to clear when switching tabs.
     * This keeps tabs isolated from each other's filters.
     */
    filterKeys?: string[];
}

export const TabFilter = (props: TabFilterProps) => {
    const viewProps = useTabFilter(props);
    return (
        <UnderlineTabBar
            id='tab-filter'
            activeKey={viewProps.active}>
            {props.keys.map((key) => {
                const isActive = viewProps.active === key;
                return (
                    <div
                        key={key}
                        role='tab'
                        aria-selected={isActive}
                        {...{ [UNDERLINE_TAB_ATTR]: key }}
                        onClick={() => {
                            if (isActive) return;
                            props.onChange?.(props.returnMap && props.returnMap.has(key) ? props.returnMap.get(key)! : key);
                            viewProps.setActive(key);
                        }}
                        className={underlineTabItemClassName(isActive)}>
                        <span className={underlineTabLabelClassName(isActive)}>{props.displayMap.get(key)}</span>
                    </div>
                );
            })}
        </UnderlineTabBar>
    );
};
